import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'semantic-ui-css/components/reset.min.css';
import 'semantic-ui-css/components/site.min.css';
import 'semantic-ui-css/components/button.min.css';
import 'semantic-ui-css/components/container.min.css';
import 'semantic-ui-css/components/divider.min.css';
import 'semantic-ui-css/components/form.min.css';
import 'semantic-ui-css/components/header.min.css';
import 'semantic-ui-css/components/image.min.css';
import 'semantic-ui-css/components/input.min.css';
import 'semantic-ui-css/components/loader.min.css';
import 'semantic-ui-css/components/message.min.css';
import 'semantic-ui-css/components/segment.min.css';
import 'semantic-ui-css/components/transition.min.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import NavBar from './components/NavBar';
import LoginPage from './pages/LoginPage';
import firebase from './utils/firebase';
import config from './utils/config';
import AccountsPage from './pages/AccountsPage';
import CheckoutPage from './pages/CheckoutPage';
import HomePage from './pages/HomePage';
import Footer from './components/Footer';
import PlansPage from './pages/PlansPage';
import BlogPage from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import Page from './components/Page';
import ReactGA from "react-ga4";

ReactGA.initialize(config.analyticsMeasurementId);

class App extends React.Component
{
  constructor(props)
  {
    super(props);
    this.state = {
      authLoaded: false,
      loggedIn: false,
      user: null,
      permissions: null,
      userEmails: [],
    }
  }
  
  componentDidMount = () =>
  {
    firebase.auth().onAuthStateChanged(async (user) => 
    {
      config.debug && console.debug(`onAuthStateChanged: sign ${!user ? 'out': 'in'}`, user);
      this.setState({
        loggedIn: user !== null,
        authLoaded: true, 
        user: user, 
      });
    });
  }

  render() 
  {
    const { loggedIn, authLoaded, user } = this.state;

    return (
      <BrowserRouter>
        <NavBar loggedIn={loggedIn} />
        <Routes>
          <Route index element={<HomePage user={user} />} />
          <Route path='account' element={<PrivateRoute authLoaded={authLoaded} loggedIn={loggedIn} page={<AccountsPage user={user}/>}/>} />
          <Route path='plans' element={<PlansPage {...this.state}/>} />
          <Route path='blog' element={<BlogPage />} />
          <Route path='blog/:slug' element={<BlogPostPage />} />
          <Route path='checkout' element={<PrivateRoute authLoaded={authLoaded} loggedIn={loggedIn} page={<CheckoutPage user={user}/>}/>} />
          <Route path='login' element={<PublicRoute authLoaded={authLoaded} loggedIn={loggedIn} page={<LoginPage />}/>} />
          <Route path='terms' element={<TermsPage />} />
          <Route path='privacy' element={<PrivacyPage />} />
          <Route path='*' element={<HomePage user={user} />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    );
  }
}

const PrivateRoute = (props) => 
{
  const { authLoaded,loggedIn,page } = props;

  var prevPathname = window.location.pathname;
  var prevSearch = window.location.search;

  return (
    authLoaded
      ? loggedIn 
        ? page 
        : <Navigate to='/login' state={{prevPathname, prevSearch}}/> 
      : <Page loading={true} />);
};

const PublicRoute = (props) => 
{
  const { authLoaded, loggedIn, page } = props;
  
  const Page = () => page;

  return authLoaded && loggedIn ? <Navigate to='/'/> : <Page/> ;
};

ReactDOM.render(<App />, document.getElementById('root'));
// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
